export const unslugify = (slug: string) => {
    return slug.split('-').join(' ');
};

export const capitalizeFirstOfEach = (str: string) => {
    return str
        .split(' ')
        .map((word) => word[0].toUpperCase() + word.slice(1))
        .join(' ');
};

export function unslugifyList(list: string[]) {
    return list
        .map((listItem) => {
            return capitalizeFirstOfEach(unslugify(listItem));
        })
        .join(', ');
}

export function unslugifyItem(item: string) {
    return capitalizeFirstOfEach(unslugify(item));
}
